import folderStore, { getEffectiveFolderDisplayName } from 'owa-folders';
import { getFolderIdForSelectedNode } from 'owa-mail-folder-forest-store';
import { formatRelativeDate } from 'owa-observable-datetime';
import Message from 'owa-service/lib/contract/Message';

export default function getItemPartTimeText(item: Message): string {
    const parentFolder = folderStore.folderTable.get(item.ParentFolderId.Id);

    // Show parent folder if item part is not being viewed within parent folder
    if (parentFolder && getFolderIdForSelectedNode() != parentFolder.FolderId.Id) {
        return getEffectiveFolderDisplayName(parentFolder);
    } else if (item.IsDraft && item.LastModifiedTime) {
        return formatRelativeDate(item.LastModifiedTime);
    } else if (item.DateTimeReceived) {
        return formatRelativeDate(item.DateTimeReceived);
    } else {
        return '';
    }
}
